module.exports = "/_next/static/images/game-1-phone-gallery-08-26-1902-uv-19ced7216e9f3c21ad904c3e4bf1fe65.jpg";